import React from 'react'
import { Button, Modal, Typography } from '@telus/koodo-ui-kit'

const PhoneNumberUnavailablePopup = ({
  isOpen,
  onClose,
  onNewPhoneNumberClick,
  unavailableNumberTitle,
  unavailableNumberMessage,
  selectNewPhoneNumberLabel
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      tokens={{
        maxWidth: 750,
        height: 'auto',
        marginRight: 0,
        headingPaddingRight: 0
      }}
    >
      <div className="text-black leading-6 text-sm">
        <Typography className="pr-10" variant={{ size: 'h3' }}>{unavailableNumberTitle}</Typography>
        <div className="mt-6 mb-9">
          <Typography variant={{ size: 'body' }}>{unavailableNumberMessage}</Typography>
        </div>
        <div className="flex flex-row md:justify-between">
          <Button
            onPress={onNewPhoneNumberClick}
            className="py-3 rounded-md font-h4"
          >
            {selectNewPhoneNumberLabel}
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default PhoneNumberUnavailablePopup
